
(function () {
  if (window.__tbtScentProfileReady) return;
  window.__tbtScentProfileReady = true;

  function showScent(variantId) {
    if (!variantId) return;

    document.querySelectorAll('#tbt-scent-profiles').forEach(function(container) {
      container.querySelectorAll('[data-tbt-variant]').forEach(function(profile) {
        profile.hidden = profile.dataset.tbtVariant !== String(variantId);
      });
    });
  }

  // Capture variant changes before Horizon updates the page.
  document.addEventListener('change', function(event) {
    const target = event.target;
    if (!(target instanceof Element)) return;

    const picker = target.closest('variant-picker');
    if (!picker || picker.closest('product-card, quick-add-dialog')) return;

    const selected = target instanceof HTMLSelectElement
      ? target.selectedOptions[0]
      : target;

    const variantId = selected?.dataset?.variantId;

    if (variantId) showScent(variantId);
  }, true);

  // Also respond when Horizon updates the variant in the URL.
  const originalReplaceState = history.replaceState;

  history.replaceState = function() {
    const result = originalReplaceState.apply(this, arguments);
    const variantId = new URLSearchParams(location.search).get('variant');
    showScent(variantId);
    return result;
  };

  // Initialize the correct scent.
  function initialize() {
    const variantId = new URLSearchParams(location.search).get('variant');
    if (variantId) showScent(variantId);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize);
  } else {
    initialize();
  }
})();
